module.exports = __webpack_public_path__ + "static/img/product_distributor.7b51d59a.png";